export default __webpack_public_path__ + "static/media/icon3.15b90ed8.png";